import { Component, Input, OnInit } from '@angular/core';
import { Tooltip } from 'bootstrap';

import { AppConfig } from 'src/app/services/app.config.services';
import { TrsEventsService } from 'src/app/services/trsevents.service';
@Component({
  selector: 'app-total-agent-time',
  templateUrl: './total-agent-time.component.html',
  styleUrls: ['./total-agent-time.component.sass']
})
export class TotalAgentTimeComponent implements OnInit {
  @Input() agentLoginStatus: boolean;
  appConfig = AppConfig.settings;
  @Input() AgentTime: any;
  LoginHours = 0;
  LoginSeconds = 0;
  LoginMinutes = 0;

  BlockHours = 0;
  BlockSeconds = 0;
  BlockMinutes = 0;

  constructor(private trsService: TrsEventsService) { }

  ngOnInit(): void {
    this.updateTheTime(this.AgentTime);
    this.trsService.evtDataObservable.subscribe(response => {

      switch (response.eventName) {
        case "AGENT_TIME": this.updateTheTime(response.data); break;
      }
    });
  }

  updateTheTime(data: any) {
    this.resetTime();
    this.AgentTime = data;
    
    if (this.AgentTime.TotalLoginTime && this.AgentTime.TotalLoginTime > 0) {
      let time = this.AgentTime.TotalLoginTime;
      this.LoginHours = Math.floor(time / 3600);
      this.LoginMinutes = Math.floor(time % 3600 / 60);
      this.LoginSeconds = Math.floor(time % 3600 % 60);
    };
    if (this.AgentTime.TotalBlockTime && this.AgentTime.TotalBlockTime > 0) {
      let time = this.AgentTime.TotalBlockTime;
      this.BlockHours = Math.floor(time / 3600);
      this.BlockMinutes = Math.floor(time % 3600 / 60);
      this.BlockSeconds = Math.floor(time % 3600 % 60);
    }
  }

  resetTime() {
    this.LoginHours = 0;
    this.LoginSeconds = 0;
    this.LoginMinutes = 0;

    this.BlockHours = 0;
    this.BlockSeconds = 0;
    this.BlockMinutes = 0;
  }

}
